module.exports = __webpack_public_path__ + "img/ivTest_sub71.155ce3b0.jpg";